
import Marquee from "react-fast-marquee"

export default function SwipperSkills() {

    const skills = [
        {
            id: 1,
            image:"/assets/icons/html.png",
            name: "HTML"
        },
        {
            id: 2,
            image: "/assets/icons/css.png",
            name: "CSS",
        },
        {
            id: 11,
            image: "/assets/icons/tailwind.png",
            name: "Tailwind"
        },
        {
            id: 12,
            image: "/assets/icons/bootstrap.png",
            name: "Bootstrap",
        },
        {
            id: 13,
            image: "/assets/icons/sass.png",
            name: "Sass"
        },
        {
            id: 3,
            image: "/assets/icons/js.png",
            name: "JavaScript"
        },
        {
            id: 4,
            image: "/assets/icons/React.png",
            name: "React"
        },
        {
            id: 5,
            image: "/assets/icons/next.jfif",
            name: "Next"
        },
        {
            id: 6,
            image: "/assets/icons/typescript.png",
            name: "TypeScript",
        },
        {
            id: 7,
            image: "/assets/icons/firebase.png",
            name: "Firebase"
        },
        {
            id: 8,
            image: "/assets/icons/git.png",
            name: "Git"
        },
        {
            id: 9,
            image: "/assets/icons/github.webp",
            name: "GitHub"
        },
        {
            id: 10,
            image: "/assets/icons/npm.png",
            name: "npm"
        },
        
        {
            id: 14,
            image: "/assets/icons/api.png",
            name: "REST API"
        },
        {
            id: 15,
            image: "/assets/icons/chadcn.png",
            name: "ChadCN"
        },
        {
            id: 16,
            image: "/assets/icons/framar.jfif",
            name: "Framer motion"
        },
        {
            id: 17,
            image: "/assets/icons/figma.png",
            name: "Figma"
        },
    ];
    return (
        <div data-aos="fade-up" className='swipper-skills'>
            <Marquee
                speed={30}
                pauseOnHover={true}
                gradient={false}
            >
                {skills.map((skill) => (
                    <div className="skill-card" key={skill.id}>
                        <img className="img-icon" src={skill.image} alt="icon" />
                        <span>{skill.name}</span>
                    </div>
                ))}
            </Marquee>

            <Marquee
                speed={30}
                pauseOnHover={true}
                gradient={false}
                direction="right"
            >
                {skills.map((skill) => (
                    <div className="skill-card" key={skill.id}>
                        <img className="img-icon" src={skill.image} alt="icon" />
                        <span>{skill.name}</span>
                    </div>
                ))}
            </Marquee>

            <Marquee
                speed={30}
                pauseOnHover={true}
                gradient={false}
            >
                {skills.map((skill) => (
                    <div className="skill-card" key={skill.id}>
                        <img className="img-icon" src={skill.image} alt="icon" />
                        <span>{skill.name}</span>
                    </div>
                ))}
            </Marquee>
        </div>
    );
}
